import { Button, Card, Col, DatePicker, Form, Input, message, Row, Upload } from "antd";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";
import { FormInstance } from "antd";
const allowedFileTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "image/jpeg",
  "image/png",
];



interface CertificatesFormProps {
  form: FormInstance;
}


const sizeLimit = 1024 * 1024 * 5;

const validateFile = (file: File) => {
  if (!allowedFileTypes.includes(file.type)) {
    message.error("Only PDF, Word, Excel, and Text files are allowed.");
    return false;
  }
  if (file.size > sizeLimit) {
    message.error("File size exceeds the 5 MB limit.");
    return false;
  }
  return true;
};

const normFile = (e: any) => {
  if (!e || !e.fileList) return [];
  return e.fileList.map((file: any) => file.originFileObj);
};

const beforeUpload = (file: File) => {
  return validateFile(file) ? true : Upload.LIST_IGNORE;
};

const CertificatestForm: React.FC<CertificatesFormProps> = ({ form }) => {


  return (
    <Form.List name="certificates">

      {(fields, { add, remove }) => (
        <div style={{ display: "flex", rowGap: 16, flexDirection: "column" }}>
          {fields.map((field) => (
            <Card
              size="small"
              title={`Certificate ${field.name + 1}`}
              key={field.key}
              extra={<CloseOutlined onClick={() => remove(field.name)} />}
            >
              <Row gutter={[48, 32]}>
                <Col span={24}>
                  <Form.Item name={[field.name, "title"]} label="Enter title of certificate">
                    <Input placeholder="e.g. MongoDB Certified Developer" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item name={[field.name, "issuedDate"]} label="Issued Date">
                    <DatePicker className="w-full" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item name={[field.name, "expiresOn"]} label="Expire Date">
                    <DatePicker className="w-full"
                      disabledDate={(current) => {
                        const startDate = form.getFieldValue(["certificates", field.name, "issuedDate"]);
                        if (!startDate) return false;
                        return current && current.isBefore(startDate, "day");
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item name={[field.name, "files"]} valuePropName="fileList" getValueFromEvent={normFile}
                    rules={[{ required: true, message: "Please upload your certificate" }]}>
                    <Upload maxCount={1} beforeUpload={beforeUpload}>
                      <Button icon={<UploadOutlined />}>Upload Certificate</Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          ))}

          {fields.length < 6 && (
            <Button type="dashed" onClick={() => add()} block>
              + Add more
            </Button>
          )}
        </div>
      )}
    </Form.List>
  );
};

export default CertificatestForm;
